import {Component, Input, OnInit} from '@angular/core';
import {StorageService} from '../../services/storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CmsService} from '../../services/cms.service';
import {VmService} from '../../services/vm.service';

@Component({
  selector: 'app-vm-tools-login',
  template: ``,
  styles: []
})
export class VmToolsLoginComponent implements OnInit {

    @Input()
	inputAdminUsername!: string;
    @Input()
	inputAdminPassword!: string;
  constructor(public cmsService: CmsService,
              private vmService: VmService,
              private storage: StorageService,
			  private routerInfo : ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
		this.routerInfo.params.subscribe(
			params => { 
				if (!!this.routerInfo.snapshot.queryParams['token']) {
						const token = this.routerInfo.snapshot.queryParams['token'];
						const identifier = this.routerInfo.snapshot.queryParams['identifier'];
						this.login(token, identifier);
				}
		});
  }

  /**
   * Login
   * vm-tools/login
   */
  login(token: any, identifier?: string){
    // this.vmService.adminLogin( this.inputAdminUsername, this.inputAdminPassword).then((result:any) => {
    //     if ( result['code'] === 1 ) {
            this.storage.setItem('admin', 'COS');
            this.storage.setItem('adminJwt', token);
            this.cmsService.sharedData.editMode = true;
            // this.storage.setItem('vmToPreview', 0);
			this.storage.setItem('vmLogin', 1 );
			this.storage.setItem('adminToken', token);
			this.storage.setItem('adminUserName', 'COSMCA');
			if (identifier) {
			    this.router.navigate(['/'+identifier]);
			} else {
			    this.router.navigate(['/']);
			}
            // history.go( 0 ); // 临时解决一个bug
            // return this.router.navigate(['/']);
   //      } else {
   //          alert( '登录失败' );
			// return;
   //      }
   //  }).catch(error => error);
  }
}
